const environment = {
  // apiBase: 'http://pco-to-wt.test/api',
  apiBase: '/api',
}

export default environment;
